export const EV_HOST = "https://test.touchaha.com:9015";
// export const HOST = "http://test.touchaha.com:8002"; //测试
//export const HOST = "https://192.168.101.115:8002"; //测试
//export const HOST = "http://192.168.101.196:8002"; //测试
// export const HOST = "http://192.168.101.115:8002"; //陈志
// export const HOST = "http://192.168.101.164:8002";  //曹李强
 //export const HOST = "https://mp.lhcd-ev.com:8002";
export const HOST = "https://kptcloud.cn:8002";//"https://106.15.233.69:8002";// //114.141.150.119:5455
//export const HOST = "http://139.196.58.250:8002";
// export const HOST = "http://192.168.101.45:8002";  //陈宇
// export const HOST = "http://192.168.101.143:8002";  //谢东
export const RESTFUL_HOST = HOST + "";
export const CAPTCHA_HOST = HOST + "/servlet/captchaServlet";



// WEBPACK FOOTER //
// ./src/utils/host.js